export const uk = {
    action: 'Действия'
};
